import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { Checkbox } from "simplydo/react/ui/checkbox";
import { Divider } from "simplydo/react/ui/divider";
import { FormField } from "simplydo/react/ui/form";
import { H5 } from "simplydo/react/ui/header";
import { Input } from "simplydo/react/ui/input";

import { IYourIdeaFilters } from "components/challenges/YourIdeas";

type YourIdeasFiltersProps = {
  setFilters: Dispatch<SetStateAction<IYourIdeaFilters>>;
  showDraft: boolean;
  showSubmitted: boolean;
  sort: string;
  filter: string;
};

const YourIdeasFilters = ({
  setFilters,
  showDraft,
  showSubmitted,
  sort,
  filter,
}: YourIdeasFiltersProps) => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: 0 }}>
      <FormField>
        <Input
          fluid
          placeholder={t("ideas.yours.sidebar.search")}
          value={filter}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilters((prevState) => ({
              ...prevState,
              filter: e.target.value,
            }))
          }
        />
      </FormField>
      <Divider hidden />
      <FormField>
        <Checkbox
          checked={showDraft}
          onChange={() =>
            setFilters((prevState) => ({ ...prevState, showDraft: !showDraft }))
          }
        >
          {t("ideas.yours.sidebar.draft")}
        </Checkbox>
        <Checkbox
          checked={showSubmitted}
          onChange={() =>
            setFilters((prevState) => ({
              ...prevState,
              showSubmitted: !showSubmitted,
            }))
          }
        >
          {t("ideas.yours.sidebar.submitted")}
        </Checkbox>
      </FormField>
      <H5>Order by</H5>
      <FormField>
        <Checkbox
          type="radio"
          name="sort"
          value="newest"
          checked={sort === "newest"}
          onChange={() =>
            setFilters((prevState) => ({ ...prevState, sort: "newest" }))
          }
        >
          {t("order.newest")}
        </Checkbox>
        <Checkbox
          type="radio"
          name="sort"
          value="oldest"
          checked={sort === "oldest"}
          onChange={() =>
            setFilters((prevState) => ({ ...prevState, sort: "oldest" }))
          }
        >
          {t("order.oldest")}
        </Checkbox>
      </FormField>
    </div>
  );
};

export default YourIdeasFilters;
